import { Router } from '@angular/router';

export function getMenuItemHref(item: { route?: (operadora: any) => any[] }, operadora: any, router: Router): string {
  if (!item.route || !operadora) return '#';

  try {
    const commands = item.route(operadora);
    const urlTree = router.createUrlTree(commands);
    return router.serializeUrl(urlTree);
  } catch {
    return '#';
  }
}

export function getMenuGroupHref(
  group: { key: string; items: Array<{ route?: (operadora: any) => any[] }> },
  operadora: any,
  router: Router,
): string {
  if (group.key === 'pesquisar') return '#';

  if (group.items.length === 1 && group.items[0].route && operadora) {
    return getMenuItemHref(group.items[0], operadora, router);
  }

  return '#';
}
